import React from 'react';
import { usePropertyPanel } from '../PropertyPanelContext';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl, BorderRadiusControl, StyleControl } from '../CommonProperties';

const ProductListProperties = () => {
  // 선택된 컴포넌트 가져오기
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컨텍스트에서 필요한 값과 함수들 가져오기
  const {
    devicePropertyTab,
    handleComponentPropsChange
  } = usePropertyPanel();
  
  return (
    <>
      
      <div className="property-row">
        <label style={{ minWidth: '30%' }}>재고 정보 표시</label>
        <div className="custom-toggle-switch">
          <input 
            id="toggle-stock-list"
            type="checkbox" 
            checked={selectedComponent.componentProps?.showStock === true}
            onChange={(e) => handleComponentPropsChange('showStock', e.target.checked)}
          />
          <label htmlFor="toggle-stock-list" className="toggle-switch-label">
            <span className="toggle-track"></span>
          </label>
        </div>
      </div>

      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M3 9H21" stroke="currentColor" strokeWidth="2" />
            <path d="M9 9V21" stroke="currentColor" strokeWidth="2" />
            <path d="M15 9V21" stroke="currentColor" strokeWidth="2" />
          </svg>
          필터링 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>포함할 상품 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.include_product_ids || ''}
            onChange={(e) => handleComponentPropsChange('include_product_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 73,74,75)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제외할 상품 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.exclude_product_ids || ''}
            onChange={(e) => handleComponentPropsChange('exclude_product_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 74,76)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>포함할 카테고리 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.include_category_ids || ''}
            onChange={(e) => handleComponentPropsChange('include_category_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 14,8)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제외할 카테고리 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.exclude_category_ids || ''}
            onChange={(e) => handleComponentPropsChange('exclude_category_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 16,17)
          </div>
        </div>
      </div>
      
      {/* 공통 속성 컴포넌트 사용 */}
      {/* <PaddingControl />
      <BorderRadiusControl />
      <StyleControl /> */}
    </>
  );
};

export default ProductListProperties; 